export const RP_FIELDS_ADMIN_SPECIFIC_EXPORT = ['acr', 'acr_previous', 'acr_level_4'];
